import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3d2df9ea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "batch-table-warp"
};
const _hoisted_2 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "cms-card-block mg-b--0 table-container"
};
const _hoisted_5 = {
  class: "header__btns"
};
const _hoisted_6 = {
  class: "table-warp"
};
const _hoisted_7 = {
  class: "btn-operate"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
import Buttons from '@/components/Buttons/index.vue';
import { nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { elMessage } from '@/utils';
import { getCurrentTime } from '@/utils/timeFormat';
import { AUDIT_STATUS_NEW } from '@/assets/config/dicts';
import { auditStatusApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    },
    pageLimit: {
      type: [String, Number],
      default: 10
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const selectTableRef = ref();
    const resonFormRef = ref();
    const TYPE_OPTION = {
      'movie': t('单片'),
      'tv_series': t('剧集')
    };
    const CODING_STATUS = {
      H264: 'H.264',
      H265: 'H.265'
    };

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const data = reactive({
      postData: {
        reason: ''
      },
      checked: false
    }); // 审批弹窗

    const dialogConfig = reactive({
      visible: false,
      action: '',
      config: {
        title: ''
      },
      confirm: done => {
        if (dialogConfig.action === 'not_approved') {
          resonFormRef.value.validate(valid => {
            if (valid) {
              batchOperation('not_approved', done, data.postData.reason.trim());
            }
          });
        } else if (dialogConfig.action === 'terminal_audit') {
          batchOperation('terminal_audit', done);
        } else if (dialogConfig.action === 'audited') {
          batchOperation('audited', done);
        }
      }
    });

    const batchOperation = async (action, done, remark) => {
      try {
        const ids = finishList.value.map(item => item.id);
        let params = {
          auditStatus: action,
          programIds: ids,
          programType: finishList.value[0].programType,
          // ifCheck: data.checked,
          releaseStatus: data.checked ? 'online' : undefined,
          remark
        };
        const res = await auditStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          dialogConfig.visible = false;
          emit('update:modelValue');
          emit('update-list');
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    watch(() => dialogConfig.visible, val => {
      if (resonFormRef.value) {
        resonFormRef.value.resetFields();
      }
    });
    const tableConfig = reactive({
      currentTagtype: 0,
      data: [],
      isCardBlock: false,
      scrollbarAlwaysOn: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: props.selectList.length
      },
      isShowHeader: false,
      config: {
        loading: false
      },
      'row-key': row => {
        return row.id;
      },
      headerButtonsList: [{
        label: '批量通过',
        type: 'success',
        func: () => {
          changeStatus('audited');
        },
        disabled: false,
        controller: btn => {
          btn.disabled = finishList.value[0] && finishList.value[0].r_auditStatus == 'audited' || hasOnline(finishList.value) ? true : false;
          return true;
        }
      }, {
        label: '批量终端审核',
        type: '',
        func: () => {
          changeStatus('terminal_audit');
        },
        disabled: false,
        controller: btn => {
          btn.disabled = finishList.value[0] && finishList.value[0].r_auditStatus == 'terminal_audit' || hasOnline(finishList.value) ? true : false;
          return true;
        }
      }, {
        label: '批量不通过',
        type: 'warning',
        func: () => {
          changeStatus('not_approved');
        },
        disabled: false,
        controller: btn => {
          btn.disabled = finishList.value[0] && finishList.value[0].r_auditStatus == 'not_approved' || hasOnline(finishList.value) ? true : false;
          return true;
        }
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        width: 260,
        sortable: true
      }, {
        label: '类型',
        prop: 'programType',
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '审核状态',
        prop: 'c_auditStatus',
        width: 160,
        sortable: true
      }, {
        label: '语言',
        prop: 'audioLanguage',
        width: 150,
        sortable: true
      }, {
        label: '编码协议',
        prop: 'videoCode',
        sortable: true,
        width: 150
      }, {
        label: '分类属性',
        prop: 'genres',
        sortable: true,
        width: 230
      }, // { label: '操作用户', prop: 'operatingUser', sortable: true, width: 150 },
      {
        label: '创建时间',
        prop: 'createTime',
        sortable: true,
        width: 190,
        formatter: val => val && getCurrentTime(val)
      }]
    });
    const finishList = ref([]);

    const handleSelectionChange = val => {
      finishList.value = val;
    };

    const copySelectList = ref([]);

    const returnAllPageFunc = async () => {
      let newArr = JSON.parse(JSON.stringify(copySelectList.value));
      newArr.forEach(item => {
        item.c_auditStatus = item.isChangeStatus === 'YES' ? `<span style="color: red">${AUDIT_STATUS_NEW[item.auditStatus]}</span>` : AUDIT_STATUS_NEW[item.auditStatus];
        item.isChangeStatus = item.isChangeStatus ? item.isChangeStatus : 'NO';
      });
      tableConfig.data = newArr.splice((tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit, tableConfig.paginationConfig.limit);
    };

    watch(() => props.modelValue, val => {
      if (val) {
        nextTick(() => {
          tableConfig.paginationConfig.limit = Number(props.pageLimit);
          finishList.value = JSON.parse(JSON.stringify(props.selectList.map(item => {
            return { ...item,
              r_auditStatus: item.auditStatus
            };
          })));
          copySelectList.value = JSON.parse(JSON.stringify(props.selectList.map(item => {
            return { ...item,
              r_auditStatus: item.auditStatus
            };
          })));
          returnAllPageFunc();
          finishList.value.forEach(row => {
            selectTableRef.value.commonTableRef.toggleRowSelection(row, true);
          });
        });
      }

      tableConfig.paginationConfig = {
        page: 1,
        limit: 10,
        total: props.selectList.length
      };
    }, {
      immediate: true,
      deep: true
    }); // 判断数组每一项的某一个属性的值是否一样

    const hasSameValue = arr => {
      if (arr.length === 0) return false;
      if (arr.length === 1) return true;
      const firstItemState = arr[0].auditStatus;
      let num = 0;

      for (let i = 1; i < arr.length; i++) {
        if (arr[i].auditStatus === firstItemState) num++;
      }

      return num === arr.length - 1 ? true : false;
    }; // 判断选中是否存在上线


    const hasOnline = arr => {
      if (arr.length === 0) return false;
      let idx = arr.findIndex(item => item.releaseStatus == 1);
      return idx > -1 ? true : false;
    };

    const changeStatus = auditStatus => {
      if (finishList.value.length === 0) {
        return elMessage('warning', '请先勾选需要批量操作的影片');
      }

      nextTick(() => {
        finishList.value.forEach(item => {
          item.auditStatus = auditStatus;
          item.c_auditStatus = `<span style="color: red">${AUDIT_STATUS_NEW[auditStatus]}</span>`;
          item.isChangeStatus = 'YES';
          copySelectList.value.forEach(selectItem => {
            if (selectItem.id === item.id) {
              selectItem.auditStatus = auditStatus;
              selectItem.c_auditStatus = `<span style="color: red">${AUDIT_STATUS_NEW[auditStatus]}</span>`;
              selectItem.isChangeStatus = 'YES';
            }
          });
          returnAllPageFunc();
        });
      });
    }; // 是否进行状态修改过


    const isChangeStatus = () => {
      let num = 0;
      finishList.value.forEach(item => {
        if (item.isChangeStatus === 'YES') {
          num++;
        }
      });
      return num !== 0 && num === finishList.value.length ? true : false;
    };

    const handleComplete = () => {
      if (finishList.value.length === 0) return elMessage('warning', '请先勾选需要批量操作的影片');
      if (!isChangeStatus()) return elMessage('warning', '请选择状态进行批量修改');
      if (!hasSameValue(finishList.value)) return elMessage('warning', '请先勾选状态相同的影片');
      let actions = finishList.value[0].auditStatus;
      console.log('actions', actions);

      switch (actions) {
        case 'audited':
          dialogConfig.config.title = '审核通过';
          dialogConfig.action = 'audited';
          break;

        case 'not_approved':
          dialogConfig.config.title = '审核不通过';
          dialogConfig.action = 'not_approved';
          break;

        case 'terminal_audit':
          dialogConfig.config.title = '终端审核';
          dialogConfig.action = 'terminal_audit';
          break;

        default:
          break;
      }

      dialogConfig.visible = true;
    };

    const back = () => {
      emit('update:modelValue', false);
      emit('update-list');
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        selectTableRef.value && selectTableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('审核')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(Buttons, {
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": columnConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_common_table, {
        extraHeight: 35,
        dynamicTableMaxHeight: "",
        pageSizesConfig: [10, 20, 40, 100, 200],
        ref_key: "selectTableRef",
        ref: selectTableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.config,
        onSelectionChange: handleSelectionChange,
        render: returnAllPageFunc
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('取消')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "btn-confirm",
        onClick: handleComplete
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('确定')), 1)]),
        _: 1
      })])])])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          top: '20vw',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [dialogConfig.action === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_form, {
          model: data.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入审核不通过原因'),
              maxlength: 100,
              modelValue: data.postData.reason,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), dialogConfig.action === 'audited' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('确认影片通过审核？')), 1), _createVNode(_component_el_checkbox, {
          modelValue: data.checked,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.checked = $event),
          label: _ctx.$t('是否直接上线影片'),
          size: "large"
        }, null, 8, ["modelValue", "label"])])) : _createCommentVNode("", true), dialogConfig.action === 'terminal_audit' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('确认将影片终端审核？')), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});